import { createModal } from "@commonlibs";
import clsx from "clsx";
import TabsModal from "ui/common/components/feedback/TabsModal/TabsModal";
import { TabsModalProps } from "ui/common/components/feedback/TabsModal/TabsModal.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import SetCaducityTab from "./SetCaducityTab";
import ConfirmUpdateCaducityTab from "./ConfirmUpdateCaducityTab";
import { UpdateCaducityState } from "./UpdateCaducityModal.types";

export interface UpdateCaducityModalProps extends Omit<TabsModalProps<UpdateCaducityState>, "tabs" | "title"> {
    className?: string;
    style?: React.CSSProperties;
}

const UPDATE_CADUCITY_TABS = [{ content: <SetCaducityTab /> }, { content: <ConfirmUpdateCaducityTab /> }];

const UpdateCaducityModal = createModal(({ className, ...rest }: UpdateCaducityModalProps) => {
    const translate = useTranslate();

    return (
        <TabsModal
            title={translate("setCaducity")}
            tabs={UPDATE_CADUCITY_TABS}
            className={clsx("update-caducity-modal", className)}
            {...rest}
        />
    );
});

export default UpdateCaducityModal;
